"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../");
var VeriLiteErrorEvent = /** @class */ (function () {
    function VeriLiteErrorEvent(content, title, actions) {
        if (title === void 0) { title = ((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.resources) === null || _b === void 0 ? void 0 : _b.Error) || "Error"; }
        if (actions === void 0) { actions = VeriLiteErrorEvent.DefaultActions(window.resources); }
        var _a, _b;
        this.content = content;
        this.title = title;
        this.actions = actions;
        this.color = "danger";
        this.backdrop = "static";
        this.closeOption = false;
        this.allowKeyboard = false;
    }
    VeriLiteErrorEvent.DefaultActions = function (resources) { return [
        new __1.VeriLiteEventAction(resources.SendErrorReport, "primary", function (currentEvent, closeModalCallback) {
            //todo error reports
            //console.log(`Send error report: ${currentEvent.content}`);
            var mail = document.createElement("a");
            mail.href = "mailto:verilite.support@reply.com?Subject=Error%20Report&Body=The%20following%20error%20was%20recieved:%0D%0A" + encodeURI(currentEvent.content.toString());
            mail.click();
            closeModalCallback();
        }),
        new __1.VeriLiteEventAction(resources.SkipSendErrorReport, "secondary", function (currentEvent, closeModalCallback) {
            closeModalCallback();
        })
    ]; };
    return VeriLiteErrorEvent;
}());
exports.VeriLiteErrorEvent = VeriLiteErrorEvent;
//# sourceMappingURL=ErrorEvents.js.map